<script setup>
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['loadMore']);

const { t } = useI18n();
</script>

<template>
  <div class="flex justify-center py-4">
    <Button
      :label="t('CONTACTS_LAYOUT.LOAD_MORE')"
      :is-loading="isLoading"
      variant="outline"
      color="slate"
      size="sm"
      class="rounded-lg bg-n-solid-1 !outline-n-weak !text-[12.5px] !text-n-slate-11"
      @click="emit('loadMore')"
    />
  </div>
</template>
